import { useEffect, useRef } from "react";
import styled from "styled-components";
import DragIndicatorIcon from "@mui/icons-material/DragIndicator";
import DirectionsBusIcon from "@mui/icons-material/DirectionsBus";
import { draggable } from "@atlaskit/pragmatic-drag-and-drop/element/adapter";

//----------------------------------

const DragHandle = styled.div`
  display: flex;
  align-items: center;
  opacity: 0.5;

  &:hover {
    opacity: 0.8;
  }

  svg {
    font-size: 16px;
  }
`;

const ItemContainer = styled.div<{ isAssigned: boolean }>`
  display: flex;
  align-items: center;
  padding: 6px 10px;
  border-radius: 4px;
  gap: 6px;
  font-size: 12px;
  background-color: ${(props) => (props.isAssigned ? "#E3FCEF" : "#FFF0E3")};
  border: 1px solid ${(props) => (props.isAssigned ? "#57D9A3" : "#FFB84D")};
  cursor: grab;
  user-select: none;

  &:hover {
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
    ${DragHandle} {
      //transform: scale(1.1);
      color: #007bff;
    }
  }

  &:active {
    cursor: grabbing;
    opacity: 0.8;
  }
`;

const Title = styled.span`
  flex: 1;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

const VehicleDraggableItem = ({
  date,
  tourGroupId,
  isAssigned,
}: {
  date: string;
  tourGroupId: string;
  isAssigned: boolean;
}) => {
  const containerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const element = containerRef.current;
    if (!element) return;

    return draggable({
      element,
      getInitialData: () => ({ date, tourGroupId }),
    });
  }, [tourGroupId, date]);

  return (
    <ItemContainer isAssigned={isAssigned} ref={containerRef}>
      <DragHandle>
        <DragIndicatorIcon />
      </DragHandle>
      <Title>Vehicle</Title>
      <DirectionsBusIcon
        sx={{
          fontSize: "13px",
          color: isAssigned ? "#57D9A3" : "rgb(177 116 26)",
        }}
      />
    </ItemContainer>
  );
};

export default VehicleDraggableItem;
